import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import { ReactComponent as UnpinSvg } from './assets/unpin.svg';

const UnpinIcon = React.forwardRef((args, ref) => <SvgIcon component={UnpinSvg} ref={ref} {...args} />);

export default UnpinIcon;
